import Vue from 'vue';
import UnreadNotificationsCount from '@/plugins/graphql/queries/v2/unread-notifications-count.gql';
import NewNotificationSubscription from '@/plugins/graphql/subscriptions/v2/notification-created.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
export default Vue.extend({
    mixins: [RouterParamsAppMixin],
    apollo: {
        unreadNotificationsCount: {
            query: UnreadNotificationsCount,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.unreadNotificationsCount.count;
            },
            subscribeToMore: {
                document: NewNotificationSubscription,
                variables() {
                    return { appUuid: this.baseAppUUID };
                },
                updateQuery(previousResult, { subscriptionData }) {
                    this.$apollo.queries.unreadNotificationsCount.refetch();
                    const notif = subscriptionData.data.notificationCreate;
                    if (notif.category === "payment_option_deactivation") {
                        this.$store.commit('navigation_drawer/showMayaReminder', true);
                    }
                    return previousResult;
                },
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            unreadNotificationsCount: 0,
        };
    },
    computed: {
        hasNew() {
            return this.unreadNotificationsCount >= 1;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                unreadNotificationsCount: this.unreadNotificationsCount,
                hasNew: this.hasNew,
            });
        }
    },
});
